import { render, staticRenderFns } from "./PodcastCards.vue?vue&type=template&id=1c3d87cb&scoped=true&"
import script from "./PodcastCards.vue?vue&type=script&lang=js&"
export * from "./PodcastCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3d87cb",
  null
  
)

export default component.exports